var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.5C4.83579 8.5 4.5 8.83579 4.5 9.25C4.5 9.66421 4.83579 10 5.25 10H14.75C15.1642 10 15.5 9.66421 15.5 9.25C15.5 8.83579 15.1642 8.5 14.75 8.5H5.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1.25C5.41421 1.25 5.75 1.58579 5.75 2V3.25H14.25V2C14.25 1.58579 14.5858 1.25 15 1.25C15.4142 1.25 15.75 1.58579 15.75 2V3.25H16.5C18.0188 3.25 19.25 4.48122 19.25 6V15C19.25 16.5188 18.0188 17.75 16.5 17.75H3.5C1.98122 17.75 0.75 16.5188 0.75 15V6C0.75 4.48122 1.98122 3.25 3.5 3.25H4.25V2C4.25 1.58579 4.58579 1.25 5 1.25ZM14.25 4.75V6C14.25 6.41421 14.5858 6.75 15 6.75C15.4142 6.75 15.75 6.41421 15.75 6V4.75H16.5C17.1904 4.75 17.75 5.30964 17.75 6V15C17.75 15.6904 17.1904 16.25 16.5 16.25H3.5C2.80964 16.25 2.25 15.6904 2.25 15V6C2.25 5.30964 2.80964 4.75 3.5 4.75H4.25V6C4.25 6.41421 4.58579 6.75 5 6.75C5.41421 6.75 5.75 6.41421 5.75 6V4.75H14.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b025146d710f0d6bf9d8e382bf6c29d0.svg";
export { ForwardRef as ReactComponent };